// extracted by mini-css-extract-plugin
export default {"chatContainer":"CurrentChat_chatContainer__+Eoie","chatContainerContent":"CurrentChat_chatContainerContent__60bDw","newConversation":"CurrentChat_newConversation__RzX32"};